import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=49640ce2&"
import script from "./Shape.vue?vue&type=script&lang=js&"
export * from "./Shape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49640ce2')) {
      api.createRecord('49640ce2', component.options)
    } else {
      api.reload('49640ce2', component.options)
    }
    module.hot.accept("./Shape.vue?vue&type=template&id=49640ce2&", function () {
      api.rerender('49640ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/utils/Badge/Shape.vue"
export default component.exports